var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_169_6833",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_169_6833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1882 7.5591C18.0628 6.55161 16.5774 6 15.0019 6C13.4264 6 11.9409 6.55544 10.8155 7.5591C9.64523 8.60479 9 10.0107 9 11.5161V11.8073C9 11.9758 9.135 12.1137 9.30007 12.1137H11.1007C11.2657 12.1137 11.4007 11.9758 11.4007 11.8073V11.5161C11.4007 9.82677 13.0175 8.45158 15.0019 8.45158C16.9862 8.45158 18.603 9.82677 18.603 11.5161C18.603 12.7075 17.7778 13.7992 16.4986 14.301C15.7033 14.6112 15.0281 15.1552 14.5442 15.8677C14.0529 16.5956 13.7977 17.469 13.7977 18.3538V19.1774C13.7977 19.3459 13.9328 19.4839 14.0979 19.4839H15.8984C16.0634 19.4839 16.1985 19.3459 16.1985 19.1774V18.3079C16.2004 17.9359 16.3121 17.5734 16.5189 17.2672C16.7256 16.9611 17.0179 16.7257 17.3576 16.5917C19.5708 15.7221 21 13.7302 21 11.5161C21.0037 10.0107 20.3586 8.60479 19.1882 7.5591ZM13.5014 23.4677C13.5014 23.8741 13.6595 24.2639 13.9409 24.5512C14.2223 24.8386 14.6039 25 15.0019 25C15.3998 25 15.7815 24.8386 16.0629 24.5512C16.3443 24.2639 16.5023 23.8741 16.5023 23.4677C16.5023 23.0613 16.3443 22.6716 16.0629 22.3842C15.7815 22.0969 15.3998 21.9355 15.0019 21.9355C14.6039 21.9355 14.2223 22.0969 13.9409 22.3842C13.6595 22.6716 13.5014 23.0613 13.5014 23.4677Z",
    fill: "#434647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b9c17a4519bfa831fd136988484c048c.svg";
export { ForwardRef as ReactComponent };